<template>
  <div style="display: contents;">
    <div :key="`tripItem-${tripItemIndex}`" class="sale-row">
      <div class="cell cell-border-right">
        <b-form-group label="Produk">
          {{ productLabel }}
        </b-form-group>
      </div>
      <div class="cell cell-border-left">
        <b-form-group label="Size">
          {{ estimationSize }}
        </b-form-group>
      </div>
      <div class="cell cell-border-right">
        <b-form-group label="Biomassa">
          {{ estimationBiomassa }}
        </b-form-group>
      </div>
      <div class="cell cell-border-left">
        <b-form-group label="Size">
          {{ notaArmadaSize }}
        </b-form-group>
      </div>
      <div class="cell cell-border-right">
        <b-form-group label="Biomassa">
          {{ notaArmadaBiomassa }}
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import {round} from "lodash";

export default {
  name: "SaleItemTripSummary",
  props: {
    tripItem: {
      type: Object,
      required: true,
    },
    tripItemIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    productLabel() {
      return this.$t(`unloads.sale_items.products.${this.tripItem.product_code}`);
    },
    estimationSize() {
      return round((Number(this.tripItem.size) || 0) * 0.9, 2);
    },
    estimationBiomassa() {
      const value = round((Number(this.tripItem.quantity) || 0) * 1.12, 2);
      return `${value} kg`;
    },
    notaArmadaSize() {
      return this.tripItem.size || 0;
    },
    notaArmadaBiomassa() {
      const value = Number(this.tripItem.quantity) || 0;
      return `${value} kg`;
    },
  },
};
</script>
